import script from "./CodyAI.vue?vue&type=script&lang=ts"
export * from "./CodyAI.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__